import { Link } from 'react-router-dom';

const steps: Array<{ title: string; text: string; to: string; action: string }> = [
  {
    title: 'E-Mail-Adresse bestätigen',
    text: 'Nach der Registrierung erhältst du eine Bestätigungs-E-Mail. Erst danach kannst du Gruppen und die Community-Freigabe nutzen.',
    to: '/settings',
    action: 'Zu den Einstellungen',
  },
  {
    title: 'Gruppe anlegen oder beitreten (optional)',
    text: 'Möchtest du Listen, Produkte und Filialen gemeinsam mit anderen nutzen, lege eine Gruppe an und lade Mitglieder ein – oder löse eine Einladung ein. Alleine kannst du direkt im persönlichen Bereich starten. Mit dem Bereichs-Umschalter wechselst du zwischen „Persönlich“ und deinen Gruppen.',
    to: '/groups',
    action: 'Zu den Gruppen',
  },
  {
    title: 'Geschäft und Filiale anlegen',
    text: 'Suche vorhandene Filialen oder finde sie über OpenStreetMap. Ein Klick auf einen Treffer übernimmt die Daten ins Formular „Neue Filiale“. Optional kannst du die Kategorien-Reihenfolge je Filiale an den Laden-Rundgang anpassen.',
    to: '/stores',
    action: 'Zu Geschäften & Filialen',
  },
  {
    title: 'Kategorien prüfen',
    text: 'Kategorien gliedern deine Einkaufsliste. Die Standardkategorien kannst du anpassen oder ergänzen.',
    to: '/categories',
    action: 'Zu den Kategorien',
  },
  {
    title: 'Produkte anlegen',
    text: 'Lege die Produkte an, die du regelmäßig kaufst – mit Kategorie, optional EAN-Barcode, Bildern und Bewertung inklusive Kommentar.',
    to: '/products',
    action: 'Zu den Produkten',
  },
  {
    title: 'Einkaufsliste anlegen',
    text: 'Erstelle eine Liste, wähle die Filiale und füge Produkte hinzu. Im Einkaufsmodus hakst du Artikel beim Einkauf in der Reihenfolge der Filiale ab.',
    to: '/lists',
    action: 'Zu den Listen',
  },
];

export function GuidePage() {
  return (
    <div className="stack">
      <h1>Erste Schritte</h1>
      <p className="muted">
        So richtest du die App nach der Registrierung oder nach dem Anlegen einer neuen Gruppe ein. Jeder Schritt gilt für den jeweils gewählten
        Bereich (persönlich oder Gruppe).
      </p>
      <ol className="list-reset stack">
        {steps.map((s, i) => (
          <li key={s.to} className="card stack">
            <h2>
              {i + 1}. {s.title}
            </h2>
            <p>{s.text}</p>
            <div>
              <Link to={s.to}>{s.action}</Link>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
